import React from "react";
import { Modal as MUIModal, Box, IconButton } from "@mui/material";
import { Custom } from "components";
import { useTheme } from "contexts";

// icons
import { CloseRounded } from "@mui/icons-material";

type Props = {
  open: boolean;
  title: string;
  size?: "small" | "medium" | "large";
  onClose: () => void;
  children: React.ReactNode;
  showCloseButton?: boolean;
};

export const Modal = ({
  open,
  onClose,
  title,
  size = "small",
  children,
  showCloseButton = true,
}: Props) => {
  const { theme } = useTheme();

  return (
    <MUIModal open={open} onClose={onClose}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "100vh", // Allows scrolling when needed
          overflowY: "auto", // Ensures the entire modal can scroll
        }}
      >
        <Box
          sx={{
            width: size === "large" ? 800 : 450,
            maxHeight: "90vh", // Prevents excessive height
            mx: theme.spacing.sm,
          }}
        >
          <Box
            sx={{
              width: 1,
              p: theme.spacing.lg,
              mb: theme.spacing.xxxl,
              display: "inline-block",
              bgcolor: theme.color.white,
              borderRadius: theme.border.radius,
            }}
          >
            {/* Title and Close Button */}
            <Box sx={{ position: "relative", textAlign: "center" }}>
              <Custom.Typography
                size={theme.font.md}
                weight={theme.font.semiBold}
              >
                {title}
              </Custom.Typography>

              {showCloseButton && (
                <IconButton
                  onClick={onClose}
                  sx={{
                    top: 0,
                    right: 0,
                    position: "absolute",
                  }}
                >
                  <CloseRounded />
                </IconButton>
              )}
            </Box>

            {/* Modal Content */}
            <Box>{children}</Box>
          </Box>
        </Box>
      </Box>
    </MUIModal>
  );
};
